import { Hidden, Link, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";

const date = new Date().getFullYear();

function Footer() {
  const order = useSelector((state) => state.order);
  return (
    <>
      <footer>
        <Typography fontSize='18px' align='center'>
          Litco Law
        </Typography>
        <Typography fontSize='15px' variant='subtitle1' align='center' color='textSecondary'>
          Copyright © {date}&nbsp;
          <Link href='https://www.litwiniuk.com/' target='_blank' style={{ textDecoration: "none" }} rel='noreferrer'>
            Litco Law
          </Link>
          &nbsp;·&nbsp;
          <Link
            href='https://www.litwiniuk.com/legal/'
            target='_blank'
            style={{ textDecoration: "none" }}
            rel='noreferrer'
          >
            Legal &amp; Privacy Policy
          </Link>
        </Typography>
      </footer>
      <Hidden xsUp={order.length === 0}>
        <Box style={{ height: 60 }}>&nbsp;</Box>
      </Hidden>
    </>
  );
}

export default Footer;
